import { venturePartner } from "../../config/business";

export function CharehyarAttribution({ variant, locale = "en" }: { variant: "footer" | "about"; locale?: "en" | "fa" }) {
  const partnerLink = <a href={venturePartner.url} target="_blank" rel="noopener noreferrer">{venturePartner.name}</a>;

  if (variant === "footer") {
    if (locale === "fa") return <span className="footer-attribution">IranTradeReach یکی از راهکارهای توسعه بازار و تجارت بین‌الملل <a href={venturePartner.url} target="_blank" rel="noopener noreferrer">چاره‌یار</a> است.</span>;
    return <span className="footer-attribution">{venturePartner.footerPrefix} {partnerLink}</span>;
  }

  if (locale === "fa") {
    return <section className="partner-attribution"><h2>پشتوانه کسب‌وکار</h2><p>{venturePartner.persianText}</p></section>;
  }

  return (
    <section className="partner-attribution" aria-labelledby="partner-attribution-title">
      <h2 id="partner-attribution-title">Our strategic foundation</h2>
      <p>{venturePartner.aboutText}</p>
    </section>
  );
}
